import { Minus, Plus } from "lucide-react";
import { useI18n } from "../../i18n";

const ModeSwitch = ({ mode, onMode, testId, small }) => {
  const { t } = useI18n();
  return (
    <div className="grid grid-cols-2 rounded-full bg-slate-100 p-0.5 text-xs font-semibold" role="radiogroup" data-testid={`${testId}-mode`}>
      {["box", "piece"].map((m) => (
        <button key={m} type="button" role="radio" aria-checked={mode === m} onClick={() => onMode(m)} data-testid={`${testId}-mode-${m}`}
          className={`${small ? "h-7 text-[11px]" : "h-8"} rounded-full transition-colors ${mode === m ? "bg-navy text-white shadow-sm" : "text-slate-600 hover:text-navy"}`}>
          {t(m === "box" ? "x.uom.boxes" : "x.uom.pieces")}
        </button>
      ))}
    </div>
  );
};

// onMode is passed only for products that can be ordered in pieces (units_per_box known)
export const QtyStepper = ({ value, onChange, testId, size = "md", mode = "box", onMode }) => {
  const { t } = useI18n();
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-9" : "h-11";
  const w = size === "sm" ? "w-9" : "w-11";
  const unit = t(mode === "piece" ? "x.uom.piece" : "x.uom.box");
  const btn = `grid ${h} ${w} shrink-0 place-items-center rounded-full bg-white text-navy shadow-sm transition-transform duration-150 active:scale-90`;
  return (
    <div className="w-full space-y-1.5">
      {onMode && <ModeSwitch mode={mode} onMode={onMode} testId={testId} small={size === "sm"} />}
      {!value ? (
        <button type="button" data-testid={`${testId}-add`} onClick={() => onChange(1)}
          className={`${h} w-full rounded-full bg-brand px-4 text-sm font-semibold text-navy transition-transform duration-150 active:scale-95 hover:bg-[#8BC21F]`}>
          {t("shop.add")}
        </button>
      ) : (
        <div className={`flex ${h} w-full items-center justify-between gap-1 rounded-full bg-brand/15 p-0`} data-testid={testId}>
          <button type="button" className={btn} onClick={() => onChange(value - 1)} aria-label="-" data-testid={`${testId}-minus`}><Minus className="h-4 w-4" /></button>
          <label className="flex min-w-0 items-baseline justify-center gap-1">
            <input type="number" inputMode="numeric" min={0} value={value} data-testid={`${testId}-input`}
              onChange={(e) => onChange(Math.max(0, parseInt(e.target.value || "0", 10) || 0))}
              className="w-10 min-w-0 bg-transparent text-center text-base font-bold tabular-nums text-navy outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none" />
            <span className="text-[11px] font-medium text-slate-600" data-testid={`${testId}-unit`}>{unit}</span>
          </label>
          <button type="button" className={btn} onClick={() => onChange(value + 1)} aria-label="+" data-testid={`${testId}-plus`}><Plus className="h-4 w-4" /></button>
        </div>
      )}
    </div>
  );
};
